import { createContext } from 'react';

export interface NotificationCountContextValue {
  unreadCount: number;
  refreshUnreadCount: () => Promise<void>;
  adjustUnreadCount: (delta: number) => void;
}

export const NotificationCountContext = createContext<NotificationCountContextValue | null>(null);
